
// jQuery.noConflict();

jQuery(function($){

    $('.load-more-btn').on('click', function(){
        var pageNumber = load_more_params.current_page;

        let $button = $(this),
            $postGrid = $button.closest('#main').find('.post-grid');

        if ($postGrid.attr('data-paged')) {
            pageNumber = $postGrid.attr('data-paged');
        }

        let data = {
            'action': 'loadmore',
            'query': load_more_params.posts,
            'page' : pageNumber
        };
        $.ajax({
            url : load_more_params.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            beforeSend : function () {
                $button.text(load_more_params.localization.loading);
            },
            success : function( response ){

                let parsedResponse = JSON.parse(response);

                $postGrid.attr("data-paged", parsedResponse['current_page']);

                if( parsedResponse.data ) {

                    $button.text( load_more_params.localization.loadMore );
                    $postGrid.append( parsedResponse.data );

                    if (parsedResponse['current_page'] >= load_more_params.max_page) {
                        $button.hide(); // if last page, remove the button
                    }
                } else {
                    $button.hide(); // if no data, remove the button as well
                }
            }
        });
    });
});